import { FC } from 'react';
import styled from '@emotion/styled';
import BottomTabBar from 'src/components/BottomTabBar';
import { BOTTOM_TAB_BAR_HEIGHT } from 'src/components/BottomTabBar';
import FooterBase from 'src/components/Footer';
import Header from 'src/components/Header';
import { TABLET_HEADER_HEIGHT } from 'src/components/Header/styles';
import withPrivateRoute from 'src/components/HOC/withPrivateRoute';
import withWebClientValidation from 'src/components/HOC/withWebClientValidation';
import ItemInventory from 'src/components/ItemInventory/ItemList';
const RootStyle = styled.div`
  width: var(--100vw);
  background-color: ${({
  theme
}) => theme.color.surface1};
`;
const ItemInventoryWrap = styled.div`
  padding: 0 16px;
  ${({
  theme
}) => theme.screenSize.tablet} {
    min-height: calc(var(--100vh) - ${TABLET_HEADER_HEIGHT} - ${BOTTOM_TAB_BAR_HEIGHT});
  }
`;
const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-top: 64px;
  ${({
  theme
}) => theme.screenSize.tablet} {
    padding-top: 54px;
  }
`;
const Footer = styled(FooterBase)`
  ${({
  theme
}) => theme.screenSize.tablet} {
    margin-bottom: 56px;
  }
`;
const ItemInventoryView: FC = () => {
  return <RootStyle data-sentry-element="RootStyle" data-sentry-component="ItemInventoryView" data-sentry-source-file="ItemInventory.tsx">
      <Header data-sentry-element="Header" data-sentry-source-file="ItemInventory.tsx" />
      <ContentWrap data-sentry-element="ContentWrap" data-sentry-source-file="ItemInventory.tsx">
        <ItemInventoryWrap data-sentry-element="ItemInventoryWrap" data-sentry-source-file="ItemInventory.tsx">
          <ItemInventory data-sentry-element="ItemInventory" data-sentry-source-file="ItemInventory.tsx" />
        </ItemInventoryWrap>
        <Footer data-sentry-element="Footer" data-sentry-source-file="ItemInventory.tsx" />
      </ContentWrap>
      <BottomTabBar data-sentry-element="BottomTabBar" data-sentry-source-file="ItemInventory.tsx" />
    </RootStyle>;
};
export default withWebClientValidation(withPrivateRoute(ItemInventoryView));